import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,
    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator,
    Text,
    PermissionsAndroid,
    Linking, I18nManager,
    Image
} from "react-native";


import {scale, moderateScale, verticalScale} from '../../../../tools/Scaling';


import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";


import i18n from '../../../../I18n/i18n.js';
//import HMImageBackground from "../../../../customviews/HMImageBackground";

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";

import {typeExport} from "../../../../redux/store/type";

import HMLoading from "../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import {connect} from "react-redux";
import axios from "axios";
import HMIcon from "../../../../customviews/HMIcon";

let container = null

class ListGigSatiaScreen extends Component {


    constructor(props) {
        super(props);

        container = this;
        this.state = {
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            indexSelectType: 0,
            list: [],

            listFilter: []
        };

        // props.callServiceRefresh();


    }

    componentDidMount() {

        // if (store.getState().reducerSplashGetAllData.TypeLogin == 2)
        this.getData()

    }


    getData() {

        this.setState({
            //ShowImage:true
            isLoading: true,
            NoInternetDialog: false,

        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('customer', this.props.DataSplashSatiaScreen.Account ? JSON.stringify(this.props.DataSplashSatiaScreen.Account) : null);


        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };

        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "services/customerGigs",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        // axios.post(typeExport._baseUrlSatia + "services/customerGigs", formData, config)
            .then(async response => {
                let data = response.data;
                let list = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;


                // data.status ? this.state.listImage.push(image) : null;

                this.setState({
                    //ShowImage:true
                    list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.status,

                })
            }).catch((e) => {

            this.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
            console.log('error', e)
        })
    }

    render() {
        // let {} = this.props.route.params
        let params = this.props.route.params ? this.props.route.params : null
        let data = params && params.item ? params.item : null
        let disableClick = (params && params.myService && params.myService.IBSExpire <= 0);


        return (
            <View style={{position: 'relative', flex: 1}}>


                {/*<HMImageBackground*/}

                {/*/>*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBarSatia
                            menu
                            back
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('Apply.title')}
                            text={data ? (data.name ? data.name : (data.title ? data.title : '')) : null}
                            //   text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />


                        <View style={{flex: 1}}>
                            {

                                disableClick ?
                                    <View
                                        style={{
                                            width: '99%',
                                            // height: moderateScale(30),
                                            //flexDirection: 'row',
                                            borderRadius: moderateScale(4),

                                            backgroundColor: Colors.warning,
                                            margin: moderateScale(4),
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            alignSelf: 'center',
                                            paddingVertical: moderateScale(8),
                                            borderWidth: moderateScale(1),
                                            borderColor: Colors.colorPrimary,
                                            padding: moderateScale(10),

                                        }}>

                                        <HMTextView
                                            text={"به دليل اينکه حساب کاربري شما دارای زمان (روز) نمی باشد ، شما امکان خريد ترافيک اضافه را نداريد لطفا از قسمت خرید سرویس اقدام فرمائید !"}
                                            // text={"dfhgdfgdfgdf"}
                                            type={"bold"}
                                            style={{
                                                //textAlign: "center",
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(14)

                                            }}/>


                                    </View>
                                    :
                                    null


                            }

                            {
                                this.state.list == null && this.state.isLoading ?
                                    <HMLoading/>

                                    :
                                    <View style={{flex: 1}}>
                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                backgroundColor: Colors.white,
                                                alignSelf: 'center'
                                                // marginVertical:moderateScale(6),
                                            }}>
                                            <View style={{
                                                flex: .5,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginVertical: moderateScale(4)
                                            }}>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={"نام"}
                                                    style={{
                                                        fontSize: moderateScale(13),

                                                        color: Colors.blackLight,
                                                        marginVertical: moderateScale(10)
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>
                                            </View>
                                            <View style={{
                                                height: '100%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43
                                            }}/>
                                            <View style={{flex: .2, alignItems: 'center', justifyContent: 'center'}}>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={"قیمت پایه" + "(" + this.props.DataSplashSatiaScreen.unit + ")"}
                                                    style={{
                                                        fontSize: moderateScale(13),

                                                        color: Colors.blackLight,
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",

                                                    }}/>
                                            </View>
                                            <View style={{
                                                height: '100%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43
                                            }}/>
                                            <View style={{flex: .2, alignItems: 'center', justifyContent: 'center'}}>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={"قیمت بسته" + "(" + this.props.DataSplashSatiaScreen.unit + ")"}
                                                    style={{
                                                        fontSize: moderateScale(13),

                                                        color: Colors.blackLight,
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",
                                                    }}/>
                                            </View>
                                            <View style={{
                                                height: '100%',
                                                width: moderateScale(1),
                                                alignSelf: 'center',
                                                backgroundColor: Colors.light43
                                            }}/>
                                            <View style={{flex: .12, alignItems: 'center', justifyContent: 'center'}}>

                                                <HMIcon name={"cart"}
                                                        style={{
                                                            fontSize: moderateScale(18),
                                                            color: Colors.blackLight,
                                                            textAlign: "center",
                                                            padding: moderateScale(4),

                                                        }}/>
                                            </View>

                                        </View>
                                        <View style={{
                                            width: '100%',
                                            height: moderateScale(1),
                                            // alignSelf: 'center',
                                            backgroundColor: Colors.light43,
                                        }}/>
                                        <FlatList
                                            style={{
                                                // alignSelf: 'center',
                                                marginTop: moderateScale(6)
                                            }}
                                            data={this.state.list}
                                            refreshing={this.state.isLoading}
                                            onRefresh={() => this.getData()}
                                            renderItem={({item, index}) => {

                                                return <TouchableOpacity
                                                    disabled={disableClick}
                                                    onPress={() => {
                                                        NavigationService.navigateParams("PaySatiaScreen", {item})

                                                        // duration:"1 ماه",
                                                        //     SubscriptionFee:"200,000 ریال",
                                                        //     SubscriptionFee:210000,
                                                        //     Discount:0,
                                                        //     SumPrice:"45,000 ریال",

                                                    }}
                                                    style={{
                                                        width: "100%",

                                                        //  width: '100%',
                                                        //  flex:1,
                                                        height: moderateScale(60),
                                                        marginBottom: moderateScale(4),
                                                        borderRadius: moderateScale(6),
                                                        borderColor: '#d0d8df',
                                                        backgroundColor:  item.ServiceType == "TT"?"#fff1dc":Colors.white,
                                                        borderWidth: moderateScale(1),
                                                        overflow: 'hidden',
                                                        //  marginVertical: moderateScale(2),
                                                        // padding: moderateScale(6)
                                                    }}>

                                                    <View
                                                        style={{width: '100%', height: "100%", flexDirection: 'row',}}>
                                                        <View
                                                            style={{
                                                                flex: .5,
                                                                // alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.Name}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.blackLight,
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                    //   textAlign: "center",
                                                                    // marginVertical: moderateScale(4),
                                                                    //marginHorizontal: moderateScale(4),

                                                                }}
                                                                styleRoot={{
                                                                    paddingHorizontal: moderateScale(10)
                                                                }}
                                                            />
                                                            {
                                                                item.ServiceType == "TT" &&
                                                                <HMTextView
                                                                    // numberOfLines={2}
                                                                    type={"bold"}
                                                                    text={"زماندار"}
                                                                    style={{
                                                                        fontSize: moderateScale(10),

                                                                        color: Colors.red,
                                                                        //  marginTop: moderateScale(4),
                                                                        //  textAlign: "right",
                                                                        //   textAlign: "center",
                                                                        marginVertical: moderateScale(4),
                                                                        marginHorizontal: moderateScale(4),

                                                                    }}
                                                                    styleRoot={{
                                                                        position: "absolute",
                                                                        top: moderateScale(1),
                                                                        right: -moderateScale(5),
                                                                        //height:moderateScale(12),
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        //  backgroundColor: "#eec42e",

                                                                        transform: [{rotate: '320deg'}],
                                                                    }}
                                                                />
                                                            }

                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>
                                                        <View
                                                            style={{
                                                                flex: .2,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={parseInt(item.Price / this.props.DataSplashSatiaScreen.unitValue)}
                                                                style={[{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.blackLight,
                                                                    marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",


                                                                }, !item.Discount || item.Discount === 0 ? {} : {
                                                                    textDecorationLine: ('line-through'),
                                                                    textDecorationColor: Colors.red,
                                                                }]}/>
                                                            {
                                                                !item.Discount || item.Discount === 0 ?
                                                                    null
                                                                    :
                                                                    <HMTextView
                                                                        cammas
                                                                        // numberOfLines={2}
                                                                        type={"bold"}
                                                                        text={parseInt((item.Price - item.Discount) / this.props.DataSplashSatiaScreen.unitValue)}
                                                                        style={{
                                                                            fontSize: moderateScale(13),

                                                                            color: Colors.green,
                                                                            marginHorizontal: moderateScale(2),
                                                                            //  marginTop: moderateScale(4),
                                                                            //  textAlign: "right",
                                                                        }}/>
                                                            }
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>
                                                        <View
                                                            style={{
                                                                flex: .2,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={parseInt(item.SumPrice / this.props.DataSplashSatiaScreen.unitValue)}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.blackLight,
                                                                    marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.light43
                                                        }}/>
                                                        <View style={{
                                                            flex: .12,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            backgroundColor: disableClick ? Colors.red : Colors.colorSecondPrimary
                                                        }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={disableClick ? "عدم خرید" : i18n.t('constant.Buy')}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white,
                                                                    marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                }}/>
                                                        </View>

                                                    </View>
                                                    {/*   <View style={{
                                                        position: 'absolute', top: 0,
                                                        bottom: 0,
                                                        right: 0,
                                                        left: 0,
                                                        zIndex: 99999,
                                                        backgroundColor: 'rgba(0,0,0,0.4)',

                                                    }}/>*/}

                                                </TouchableOpacity>
                                            }}


                                        />
                                    </View>

                            }


                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.state.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>


            </View>
        );
    }

    renderItems = ({item, index}) => {

        return <TouchableOpacity
            onPress={() => {
                NavigationService.navigateParams("PaySatiaScreen", {item})

                // duration:"1 ماه",
                //     SubscriptionFee:"200,000 ریال",
                //     SubscriptionFee:210000,
                //     Discount:0,
                //     SumPrice:"45,000 ریال",

            }}
            style={{
                width: typeExport.WIDTH - moderateScale(8),

                //  width: '100%',
                //  flex:1,
                // height: typeExport.WIDTH / 3,
                marginBottom: moderateScale(4),
                borderRadius: moderateScale(6),
                borderColor: '#d0d8df',
                backgroundColor: Colors.white,
                borderWidth: moderateScale(1),
                overflow: 'hidden'
                //  marginVertical: moderateScale(2),
                // padding: moderateScale(6)
            }}>

            <View style={{width: '100%', flexDirection: 'row', marginVertical: moderateScale(6)}}>
                <View style={{flex: .5, alignItems: 'center', justifyContent: 'center'}}>
                    <HMTextView
                        // numberOfLines={2}
                        // type={"bold"}
                        text={item.Name}
                        style={{
                            fontSize: moderateScale(12),

                            color: Colors.blackLight
                            //  marginTop: moderateScale(4),
                            //  textAlign: "right",
                        }}/>
                </View>
                <View style={{
                    height: '99%',
                    width: moderateScale(1),
                    alignSelf: 'center',
                    backgroundColor: Colors.gray
                }}/>
                <View style={{flex: .24, alignItems: 'center', justifyContent: 'center'}}>
                    <HMTextView
                        // numberOfLines={2}
                        //type={"bold"}
                        text={"قیمت هر گیگ(تومان)"}
                        style={{
                            fontSize: moderateScale(12),

                            color: Colors.blackLight
                            //  marginTop: moderateScale(4),
                            //  textAlign: "right",
                        }}/>
                </View>
                <View style={{
                    height: '99%',
                    width: moderateScale(1),
                    alignSelf: 'center',
                    backgroundColor: Colors.gray
                }}/>
                <View style={{flex: .24, alignItems: 'center', justifyContent: 'center'}}>
                    <HMTextView
                        // numberOfLines={2}
                        // type={"bold"}
                        text={"قیمت بسته(تومان)"}
                        style={{
                            fontSize: moderateScale(12),

                            color: Colors.blackLight
                            //  marginTop: moderateScale(4),
                            //  textAlign: "right",
                        }}/>
                </View>

            </View>


        </TouchableOpacity>
    }


}

const mapStateToProps = state => {
    return {

        user: state.reducerSplashSatiaScreen.user,
        token: state.reducerSplashSatiaScreen.token,
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        //   callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(ListGigSatiaScreen);
